import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Icon from '../AppIcon';
import cn from 'classnames';

const Sidebar = ({ isOpen = false, onClose, userRole = 'admin' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    {
      label: 'لوحة العقارات',
      icon: 'Building2',
      path: '/property-management-dashboard',
      roles: ['admin', 'property_manager', 'contract_specialist', 'client_manager'],
      badge: null,
    },
    {
      label: 'قوائم العقارات',
      icon: 'List',
      path: '/property-listing-creation-and-management',
      roles: ['admin', 'property_manager'],
      badge: null,
    },
    {
      label: 'العملاء',
      icon: 'Users',
      path: '/client-relationship-management',
      roles: ['admin', 'property_manager', 'client_manager'],
      badge: 3,
    },
    {
      label: 'التقويم والمواعيد',
      icon: 'Calendar',
      path: '/calendar-and-appointment-scheduling',
      roles: ['admin', 'property_manager', 'client_manager'],
      badge: null,
    },
    {
      label: 'العقود',
      icon: 'FileText',
      path: '/contract-approval-workflow',
      roles: ['admin', 'contract_specialist'],
      badge: 5,
    },
    {
      label: 'تتبع التوقيعات',
      icon: 'FileSignature',
      path: '/signature-tracking',
      roles: ['admin', 'contract_specialist'],
      badge: null,
    },
    {
      label: 'الملاك',
      icon: 'UserCheck',
      path: '/owner-property-management',
      roles: ['admin', 'property_manager'],
      badge: null,
    },
    {
      label: 'التواصل',
      icon: 'MessageSquare',
      path: '/communication-and-follow-up-center',
      roles: ['admin', 'client_manager'],
      badge: 12,
    },
    {
      label: 'المستندات',
      icon: 'FileCheck',
      path: '/document-and-form-generation-center',
      roles: ['admin', 'contract_specialist', 'property_manager'],
      badge: null,
    },
    {
      label: 'التقارير',
      icon: 'BarChart3',
      path: '/reporting-and-analytics-dashboard',
      roles: ['admin'],
      badge: null,
    },
    {
      label: 'موافقات التسجيل',
      icon: 'UserCheck',
      path: '/user-registration-approval-dashboard',
      roles: ['admin'],
      badge: null,
    },
    {
      label: 'إدارة النظام',
      icon: 'Settings',
      path: '/system-administration-and-user-management',
      roles: ['admin'],
      badge: null,
    },
  ];

  const filteredNavigation = navigationItems?.filter(item => 
    item?.roles?.includes(userRole)
  );

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const isActive = (path) => location?.pathname === path;

  return (
    <>
      {isOpen && (
        <div 
          className="sidebar-overlay fixed inset-0 bg-black/70 backdrop-blur-sm z-[99] transition-all duration-300 cursor-pointer"
          onClick={onClose}
          aria-hidden="true"
          role="button"
          aria-label="إغلاق القائمة"
        >
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="text-white/40 text-sm font-medium bg-black/30 px-4 py-2 rounded-lg backdrop-blur-md">
              انقر في أي مكان للإغلاق
            </div>
          </div>
        </div>
      )}
      <aside className={`sidebar ${!isOpen && window.innerWidth < 1024 ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}>
        {/* Prominent Close Button - Top Right Corner */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2.5 rounded-md bg-white hover:bg-white/90 transition-all duration-200 shadow-lg hover:shadow-xl border border-white/20"
          aria-label="إغلاق القائمة"
          title="إغلاق القائمة"
        >
          <Icon name="X" size={22} color="#000000" />
        </button>

        <div className="sidebar-header">
          <div className="flex flex-col items-center gap-3">
            <div className="w-20 h-20 rounded-md overflow-hidden bg-white flex items-center justify-center shadow-2xl border border-white/20">
              <img 
                src="/assets/images/Apropapplogo-1768301171635.jpg" 
                alt="ARDDJO Logo" 
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {filteredNavigation?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={cn(
                'sidebar-nav-item',
                location?.pathname === item?.path && 'active bg-gradient-to-r from-gold/20 to-gold/10 border-gold/40 text-gold'
              )}
              onClick={() => onClose()}
            >
              <Icon name={item?.icon} size={20} color={location?.pathname === item?.path ? '#D4AF37' : '#FFFFFF'} />
              <span className="flex-1 text-right">{item?.label}</span>
              {item?.badge && (
                <span className="badge bg-gold text-black">{item?.badge}</span>
              )}
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;